import { useEffect, useState } from "react";

export default function SplashScreen({ onFinish }) {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(false);
      onFinish(); // يخبر التطبيق إن التحميل خلص
    }, 2000); // مدة الظهور (2 ثانية)
    return () => clearTimeout(timer);
  }, [onFinish]);

  return (
    <div
      className={`fixed inset-0 flex items-center justify-center bg-cream transition-opacity duration-700 ${
        visible ? "opacity-100 z-50" : "opacity-0 -z-10"
      }`}
    >
      <img
        src="/zuccesslogo2.png"
        alt="Zuccess Logo"
        className="w-80 h-80 animate-pulse drop-shadow-lg transition-transform duration-700 scale-100"
      />
    </div>
  );
}
